import React, { useEffect } from 'react';
import { fetchStoreInfoBySubDomain } from 'src/redux/actions';
import Error404 from '@/containers/404Page/index';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { isWebsiteInternallyRouted } from '@/utils/isWebsiteInternallyRouted';

const ErrorPage = () => {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    if (router.query.domain) {
      const isCustomDomain = isWebsiteInternallyRouted(window.location.host);
      const domainName = `${isCustomDomain ? 'd-' : ''}${router.query.domain}`;

      dispatch(fetchStoreInfoBySubDomain(domainName));
    }
  }, [router.query.domain]);

  return (
    <>
      <Error404 />
    </>
  );
};

export default ErrorPage;
